(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebmini-product-fit-guide"]) return;
  try {
    
  const initializeRealMedia = (scope = document) => {
    scope.querySelectorAll('[data-eb-real-media]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-eb-real-media-track]');
      const previous = carousel.querySelector('[data-eb-real-media-prev]');
      const next = carousel.querySelector('[data-eb-real-media-next]');
      if (!track) return;

      const scrollOneCard = (direction) => {
        const card = track.querySelector('.eb-real-media__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scrollOneCard(-1));
      next?.addEventListener('click', () => scrollOneCard(1));

      let dragging = false;
      let startX = 0;
      let startScroll = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.target.closest('video')) return;
        dragging = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        track.scrollLeft = startScroll - (event.clientX - startX);
      });

      const stopDragging = () => {
        dragging = false;
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
    });
  };

  initializeRealMedia();
  document.addEventListener('shopify:section:load', (event) => initializeRealMedia(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
